<div class="premium-modal-wrapper">
    <ion-header class="ion-no-border premium-header">
        <div class="header-curve"></div>
        <div class="custom-toolbar">
            <div class="toolbar-content">
                <div class="icon-btn" (click)="close()">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div class="title-group">
                    <div class="title-main" *ngIf="cotizacion">Cotización #{{ cotizacion.id }}</div>
                    <div class="title-sub">Gestión de Presupuesto</div>
                </div>
            </div>
        </div>
    </ion-header>

    <ion-content class="premium-content-bg menu-content">

        <!-- Top Actions: Edit & Delete -->
        <div class="top-actions">
            <div class="action-card edit" (click)="edit()">
                <ion-icon name="create-outline"></ion-icon>
                <span>Editar</span>
            </div>
            <div class="action-card delete" (click)="confirmDelete()">
                <ion-icon name="trash-outline"></ion-icon>
                <span>Eliminar</span>
            </div>
        </div>

        <!-- Circular Quick Actions -->
        <div class="section-label">
            <span class="label-line"></span>
            <span class="label-text">Acciones rápidas</span>
            <span class="label-line"></span>
        </div>
        <div class="quick-actions">
            <div class="circle-action" (click)="openComments()">
                <div class="circle-icon comments">
                    <ion-icon name="chatbubbles-outline"></ion-icon>
                </div>
                <span class="circle-label">Comentarios</span>
            </div>
            <div class="circle-action" (click)="viewPdf()" *ngIf="isWeb">
                <div class="circle-icon view-pdf">
                    <ion-icon name="eye-outline"></ion-icon>
                </div>
                <span class="circle-label">Ver PDF</span>
            </div>
            <div class="circle-action" (click)="sharePdf()">
                <div class="circle-icon share-pdf">
                    <ion-icon name="share-social-outline"></ion-icon>
                </div>
                <span class="circle-label">Compartir</span>
            </div>
            <div class="circle-action" (click)="openSeguimiento()">
                <div class="circle-icon tracking">
                    <ion-icon name="footsteps-outline"></ion-icon>
                </div>
                <span class="circle-label">Seguimiento</span>
            </div>
            <div class="circle-action" (click)="abrirEnviarCorreo()">
                <div class="circle-icon send-mail">
                    <ion-icon name="mail-outline"></ion-icon>
                </div>
                <span class="circle-label">Enviar Correo</span>
            </div>
            <div class="circle-action" (click)="clone()">
                <div class="circle-icon clone">
                    <ion-icon name="copy-outline"></ion-icon>
                </div>
                <span class="circle-label">Clonar</span>
            </div>
        </div>

        <!-- Asignaciones -->
        <div class="info-section">
            <div class="section-label">
                <span class="label-line"></span>
                <span class="label-text">Asignaciones</span>
                <span class="label-line"></span>
            </div>
            <div class="section-card">
                <div class="info-row clickable" (click)="goToInspeccion()">
                    <div class="row-icon-wrap inspeccion-icon-wrap">
                        <ion-icon name="search-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Inspección</span>
                        <span class="row-value" *ngIf="cotizacion?.inspeccionId && cotizacion.inspeccionId !== '0'">#{{ cotizacion?.inspeccionId }}</span>
                        <span class="row-value muted" *ngIf="!cotizacion?.inspeccionId || cotizacion.inspeccionId === '0'">Sin inspección vinculada</span>
                    </div>
                    <div class="unlink-mini-btn" *ngIf="cotizacion?.inspeccionId && cotizacion.inspeccionId !== '0'" (click)="$event.stopPropagation(); unlinkFromInspeccion()">
                        <ion-icon name="unlink-outline"></ion-icon>
                    </div>
                    <ion-icon name="chevron-forward-outline" class="row-arrow" *ngIf="cotizacion?.inspeccionId && cotizacion.inspeccionId !== '0'"></ion-icon>
                    <div class="add-mini-btn inspeccion-add-btn" *ngIf="!cotizacion?.inspeccionId || cotizacion.inspeccionId === '0'" (click)="$event.stopPropagation(); addInspeccionFromMenu()">
                        <ion-icon name="add-outline"></ion-icon>
                    </div>
                </div>

                <div class="info-row last-row clickable" (click)="goToTrabajo()">
                    <div class="row-icon-wrap trabajo-icon-wrap">
                        <ion-icon name="briefcase-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Trabajo</span>
                        <span class="row-value" *ngIf="cotizacion?.trabajoId && cotizacion.trabajoId !== '0'">#{{ cotizacion?.trabajoId }}</span>
                        <span class="row-value muted" *ngIf="!cotizacion?.trabajoId || cotizacion.trabajoId === '0'">Sin trabajo asignado</span>
                    </div>
                    <div class="unlink-mini-btn" *ngIf="cotizacion?.trabajoId && cotizacion.trabajoId !== '0' && permissions?.trabajos?.rl_editar_cotizacion !== false" (click)="$event.stopPropagation(); unlinkFromTrabajo()">
                        <ion-icon name="unlink-outline"></ion-icon>
                    </div>
                    <ion-icon name="chevron-forward-outline" class="row-arrow" *ngIf="cotizacion?.trabajoId && cotizacion.trabajoId !== '0'"></ion-icon>
                    <div class="add-mini-btn" *ngIf="!cotizacion?.trabajoId || cotizacion.trabajoId === '0'" (click)="$event.stopPropagation(); addTrabajoFromMenu()">
                        <ion-icon name="add-outline"></ion-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- Resumen Financiero -->
        <div class="info-section">
            <div class="section-label">
                <span class="label-line"></span>
                <span class="label-text">Resumen Financiero</span>
                <span class="label-line"></span>
            </div>
            <div class="section-card financial-card">
                <div class="financial-summary-grid" [class.single-col]="!(cotizacion?.itbms > 0)">
                    <div class="financial-grid-item">
                        <span class="grid-label">Subtotal</span>
                        <span class="grid-value">${{ cotizacion?.precio | number:'1.2-2' }}</span>
                    </div>
                    <div class="financial-grid-item border-left" *ngIf="cotizacion?.itbms > 0">
                        <span class="grid-label">ITBMS</span>
                        <span class="grid-value">${{ cotizacion?.itbms | number:'1.2-2' }}</span>
                    </div>
                </div>
                <div class="financial-total-row">
                    <div class="total-icon-wrap">
                        <ion-icon name="cash-outline"></ion-icon>
                    </div>
                    <div class="total-body">
                        <span class="total-label">Total de la Cotización</span>
                        <span class="total-value">${{ cotizacion?.precioTotal | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Facturación y Pagos -->
        <div class="info-section" *ngIf="billingInfo && (billingInfo.facturaEmpresa || billingInfo.facturaFiscal || billingInfo.paquete || billingInfo.fechaPago)">
            <div class="section-label">
                <span class="label-line"></span>
                <span class="label-text">Facturación y Pagos</span>
                <span class="label-line"></span>
            </div>
            <div class="section-card">
                <div class="billing-badges" *ngIf="billingInfo.facturaEmpresa || billingInfo.facturaFiscal || billingInfo.paquete">
                    <div class="billing-badge empresa" *ngIf="billingInfo.facturaEmpresa">
                        <ion-icon name="document-outline"></ion-icon>
                        <span>Empresa #{{ billingInfo.facturaEmpresa }}</span>
                    </div>
                    <div class="billing-badge fiscal" *ngIf="billingInfo.facturaFiscal">
                        <ion-icon name="receipt-outline"></ion-icon>
                        <span>Fiscal #{{ billingInfo.facturaFiscal }}</span>
                    </div>
                    <div class="billing-badge paquete" *ngIf="billingInfo.paquete">
                        <ion-icon name="archive-outline"></ion-icon>
                        <span>{{ billingInfo.paquete }}</span>
                    </div>
                </div>

                <div class="info-row" [class.last-row]="!billingInfo.fechaPago" *ngIf="billingInfo.fechaPago">
                    <div class="row-icon-wrap icon-positive">
                        <ion-icon name="calendar-outline"></ion-icon>
                    </div>
                    <div class="row-body" style="flex: 1;">
                        <span class="row-label">Fecha de Pago</span>
                        <span class="row-value">{{ billingInfo.fechaPago | date:'mediumDate' }}</span>
                    </div>
                    <ion-badge color="success" mode="ios" style="margin-left: auto;">{{ billingInfo.tipoPago }}</ion-badge>
                </div>

                <div class="no-payment" *ngIf="!billingInfo.fechaPago && (billingInfo.facturaEmpresa || billingInfo.facturaFiscal)">
                    <ion-icon name="time-outline"></ion-icon>
                    <span>Pago todavía pendiente</span>
                </div>
            </div>
        </div>

        <!-- Información Detallada -->
        <div class="info-section">
            <div class="section-label">
                <span class="label-line"></span>
                <span class="label-text">Información Detallada</span>
                <span class="label-line"></span>
            </div>
            <div class="section-card">
                <!-- Estado -->
                <div class="info-row clickable" (click)="changeStatus()">
                    <div class="row-icon-wrap" [ngStyle]="{background: getEstadoColor().color + '20'}">
                        <ion-icon name="flag-outline" [ngStyle]="{color: getEstadoColor().color}"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Estado de la Cotización</span>
                        <span class="row-value" [ngStyle]="{color: getEstadoColor().color}">{{ cotizacion?.estado }}</span>
                    </div>
                    <ion-icon name="chevron-down-outline" class="row-arrow" style="font-size: 1.1rem; color: #b2bec3;"></ion-icon>
                </div>

                <!-- Solicitante -->
                <div class="info-row" *ngIf="cotizacion?.solicitante">
                    <div class="row-icon-wrap">
                        <ion-icon name="person-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Solicitante</span>
                        <span class="row-value">{{ cotizacion?.solicitante }}</span>
                    </div>
                </div>

                <!-- Fecha -->
                <div class="info-row" *ngIf="cotizacion?.fecha">
                    <div class="row-icon-wrap">
                        <ion-icon name="calendar-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Fecha de Solicitud</span>
                        <span class="row-value">{{ cotizacion?.fecha | date:'mediumDate' }}</span>
                    </div>
                </div>

                <!-- Materiales -->
                <div class="info-row">
                    <div class="row-icon-wrap" [class.icon-positive]="cotizacion?.materiales === 'Y'" [class.icon-negative]="cotizacion?.materiales !== 'Y'">
                        <ion-icon name="construct-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Herramientas y Materiales</span>
                        <span class="row-value" [class.positive]="cotizacion?.materiales === 'Y'" [class.negative]="cotizacion?.materiales !== 'Y'">
                            {{ cotizacion?.materiales === 'Y' ? 'Incluidos en el presupuesto' : 'No incluidos' }}
                        </span>
                    </div>
                </div>

                <!-- PPC -->
                <div class="info-row">
                    <div class="row-icon-wrap" [class.icon-positive]="cotizacion?.ppc === 'Y'" [class.icon-negative]="cotizacion?.ppc !== 'Y'">
                        <ion-icon name="color-palette-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Pintura de Primera Calidad</span>
                        <span class="row-value" [class.positive]="cotizacion?.ppc === 'Y'" [class.negative]="cotizacion?.ppc !== 'Y'">
                            {{ cotizacion?.ppc === 'Y' ? 'Sí (Aplica PPC)' : 'No (Pintura estándar)' }}
                        </span>
                    </div>
                </div>

                <!-- Cliente -->
                <div class="info-row" *ngIf="cotizacion?.cliente">
                    <div class="row-icon-wrap">
                        <ion-icon name="business-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Cliente / Empresa</span>
                        <span class="row-value">{{ cotizacion?.cliente }}</span>
                    </div>
                </div>

                <!-- Dirección -->
                <div class="info-row" [class.last-row]="!cotizacion?.descripcion && !cotizacion?.observacion" *ngIf="cotizacion?.direccion">
                    <div class="row-icon-wrap">
                        <ion-icon name="location-outline"></ion-icon>
                    </div>
                    <div class="row-body">
                        <span class="row-label">Dirección de Ubicación</span>
                        <span class="row-value">{{ cotizacion?.direccion }}</span>
                    </div>
                </div>

                <!-- Descripción -->
                <div class="info-row row-stacked" [class.last-row]="!cotizacion?.observacion" *ngIf="cotizacion?.descripcion">
                    <div class="stacked-header">
                        <ion-icon name="document-text-outline"></ion-icon>
                        <span class="row-label">Descripción General</span>
                    </div>
                    <p class="stacked-value">{{ cotizacion?.descripcion }}</p>
                </div>

                <!-- Observaciones -->
                <div class="info-row row-stacked last-row" *ngIf="cotizacion?.observacion">
                    <div class="stacked-header">
                        <ion-icon name="reader-outline"></ion-icon>
                        <span class="row-label">Observaciones Adicionales</span>
                    </div>
                    <p class="stacked-value">{{ cotizacion?.observacion }}</p>
                </div>
            </div>
        </div>

        <div class="bottom-spacer" style="height: 32px;"></div>

    </ion-content>
    <ion-footer class="ion-no-border premium-list-footer"></ion-footer>
</div>